export default "__VITE_ASSET__1QfZ_iFs__"